/**
 * @fileoverview Utilities para formatar timestamps relativos no UI
 * (ex.: "há 5 min", "há 2h"). Usado em badges de "última sincronização",
 * "atualizado em", etc.
 */

/**
 * Recebe uma string ISO ou Date e devolve um texto curto em português
 * comparando com o "agora". Quando o valor é nulo/inválido, devolve
 * `fallback` (default "nunca").
 */
export function formatRelativeTime(value, fallback = "nunca") {
  if (!value) return fallback;
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return fallback;

  const diffMin = Math.round((Date.now() - d.getTime()) / 60000);
  if (diffMin < 1) return "agora mesmo";
  if (diffMin < 60) return `há ${diffMin} min`;
  const diffH = Math.round(diffMin / 60);
  if (diffH < 24) return `há ${diffH}h`;
  return `há ${Math.round(diffH / 24)}d`;
}
